import { useDispatch, useSelector } from 'react-redux';
import CardsSection from './components/CardsSection';
import SummarySection from './components/SummarySection';
import './dashboardPantalla.scss';
import { useEffect } from 'react';
import {
    fetchDashboardPantalla,
    fetchRefreshDashboardPantalla,
} from '../../../../redux/dashboardPantalla';
import Loading from '../shared/components/Loading'


const DashboardPantalla = () => {
    const dispatch = useDispatch();
    const dashboardPantalla = useSelector((state) => {
        return state.dashboardPantalla;
    });

    useEffect(() => {
        dispatch(fetchDashboardPantalla());

        const interval = setInterval(() => {
            dispatch(fetchRefreshDashboardPantalla());
        }, 10 * 60 * 1000);

        return () => clearInterval(interval);
    }, [dispatch]);

    return (
        <div className="dashboard-pantalla">
            {dashboardPantalla.isLoading ? (
                <Loading />
            ) : (
                <>
                    <CardsSection data={dashboardPantalla?.cards} />
                    <SummarySection data={dashboardPantalla?.summary} />
                </>
            )}
        </div>
    );
};

export default DashboardPantalla;
